import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Accordion from "@/components/base/Accordion";
import { homeFaqPreview } from "@/mocks/public";

export default function FaqPreviewSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-page">
        <SectionHeading
          eyebrow="FAQ"
          title="Questions fréquentes"
          description="Vous vous demandez si la plateforme convient à votre situation ? Voici les réponses les plus utiles."
        />
        <div className="mx-auto mt-12 max-w-3xl">
          <Accordion items={homeFaqPreview} />
          <div className="mt-8 flex justify-center">
            <Link
              to="/faq"
              className="link-arrow inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-5 py-2.5 text-sm font-label font-medium text-foreground-900 hover:bg-background-100 hover:-translate-y-0.5 transition-all cursor-pointer"
            >
              Voir toutes les questions
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}